/** Normalize user input to a string suitable for `new URL()` (add https:// when scheme omitted). */
export function normalizeResourceUrl(input: string): string {
  const t = input.trim();
  if (!t) return '';
  if (/^https?:\/\//i.test(t)) return t;
  return `https://${t}`;
}

/** True only for well-formed http(s) URLs (blocks javascript:, data:, etc.). */
export function isValidHttpOrHttpsUrl(input: string): boolean {
  const n = normalizeResourceUrl(input);
  if (!n) return false;
  try {
    const u = new URL(n);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    if (!u.hostname || u.hostname.length === 0) return false;
    return true;
  } catch {
    return false;
  }
}
